import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable, switchMap, take } from 'rxjs';

import { CsrfTokenService } from '../service';

export const CsrfTokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const csrfTokenService: CsrfTokenService = inject(CsrfTokenService);

  const excludedPaths: string[] = [
    '/api/auth/send-magic-link',
    '/api/auth/signup',
    '/api/auth/magic-link-verify',
    '/api/auth/password-signin',
    '/api/auth/2fa',
    '/api/auth/request-password-reset',
    '/api/auth/verify-password-reset',
    '/api/auth/reset-password',
    '/api/verify',
    '/api/security-alert',
  ];

  const excludedMethods: string[] = ['GET', 'HEAD', 'OPTIONS'];

  const shouldExclude =
    excludedPaths.some((path) => request.url.includes(path)) ||
    excludedMethods.includes(request.method);

  if (shouldExclude) {
    return next(request);
  }

  return csrfTokenService.csrfToken.pipe(
    take(1),
    switchMap((token: string | null) => {
      if (token) {
        request = request.clone({
          setHeaders: {
            'x-csrf-token': token,
          },
        });
      }
      return next(request);
    }),
  );
};
